var defaultVaryings = "\nvarying vec3 vVertexPosition;\nvarying vec2 vTextureCoord;\n";
export default defaultVaryings.replace(/\n/g, '');